/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Cargo_PlaceholderInputs */

const en_search_cargo_placeholder = /** @type {(inputs: Search_Cargo_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search cargo...`)
};

const es_search_cargo_placeholder = /** @type {(inputs: Search_Cargo_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar carga...`)
};

/**
* | output |
* | --- |
* | "Search cargo..." |
*
* @param {Search_Cargo_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_cargo_placeholder = /** @type {((inputs?: Search_Cargo_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Cargo_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_cargo_placeholder(inputs)
	return es_search_cargo_placeholder(inputs)
});